/**
 * Normalize a domain or URL paste to a hostname for allowlist matching.
 * Strips protocol, path, port, trailing slash; lowercases; trims.
 */
function normalizeDomain (input) {
  if (input == null) return ''
  let value = String(input).trim().toLowerCase()
  if (!value) return ''

  // Strip protocol if present
  value = value.replace(/^[a-z][a-z0-9+.-]*:\/\//, '')

  // Strip path / query / hash (keep host:port for now)
  const slashIdx = value.search(/[/?#]/)
  if (slashIdx !== -1) {
    value = value.slice(0, slashIdx)
  }

  // Strip trailing dots/slashes leftover
  value = value.replace(/\.+$/, '').replace(/\/+$/, '')

  // Strip port
  if (value.includes(':') && !value.startsWith('[')) {
    // IPv6 in brackets not expected for widget hosts; drop :port for hostnames
    const lastColon = value.lastIndexOf(':')
    const maybePort = value.slice(lastColon + 1)
    if (/^\d+$/.test(maybePort)) {
      value = value.slice(0, lastColon)
    }
  }

  return value
}

/**
 * Parse textarea / array into a deduped list of normalized domains.
 */
function parseAllowedDomains (textOrArray) {
  const lines = Array.isArray(textOrArray)
    ? textOrArray
    : String(textOrArray || '').split('\n')

  const seen = new Set()
  const result = []
  for (const line of lines) {
    const domain = normalizeDomain(line)
    if (!domain || seen.has(domain)) continue
    seen.add(domain)
    result.push(domain)
  }
  return result
}

/**
 * Empty allowlist means unrestricted. Otherwise exact hostname match after normalize.
 */
function isHostAllowed (hostname, allowedDomains) {
  if (!allowedDomains || !allowedDomains.length) return true
  const host = normalizeDomain(hostname)
  if (!host) return false
  const allowed = parseAllowedDomains(allowedDomains)
  return allowed.includes(host)
}

export {
  normalizeDomain,
  parseAllowedDomains,
  isHostAllowed
}
